/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import CardsSimpleItem from "./cards-simple-item";
import { isArrayNotEmpty  } from "cms/utils/empty-exists";

const CardsSimpleComponent = (props) => {

    const { component } = props;
    const { card_list } = component || {};

    return (
        <div className={"cards-simple-component"}>
            {isArrayNotEmpty(card_list) &&
                card_list.map((item, index) => (
                    <CardsSimpleItem
                        key={index}
                        item={item}
                    />
                ))
            }
        </div>
    );
};

CardsSimpleComponent.displayName ="CardsSimpleComponent";
export { CardsSimpleComponent };
